import { apiGet, GetReportRequest } from 'api';
import { ReportResponse } from 'types';

export const getRespondedOnTimeReport = (request: GetReportRequest): Promise<ReportResponse> =>
  apiGet<ReportResponse, GetReportRequest>('reports/respondedontime', request);
